import { memo } from 'react'

import { Badge } from '../../../../Badge/Badge'
import { type FilterOption } from '../../multi-select/filterTypeConfig'

export const CheckboxBadgeOption = memo(
  ({ option }: Readonly<{ option: FilterOption }>) => (
    <Badge color={option.badgeColor} withDot={option.badgeWithDot ?? true}>
      {option.label}
    </Badge>
  )
)
CheckboxBadgeOption.displayName = 'CheckboxBadgeOption'
